import React, { useCallback, useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import usePortal from "./usePortal";
import { Alert } from "@showitinc/showit-wc";
import UIActions from "../actions/UIActions";

const toastHost = document.getElementById("si-toast");

const toggleTopLayer =
  (visible) => {
    const action = visible ? "showPopover" : "hidePopover";
    toastHost?.[action]?.();
  };

const handleClose = () => {
  requestAnimationFrame(() => {
    toggleTopLayer(false);
  });
  UIActions.hideToast();
};

toastHost.addEventListener("si-close", handleClose);

const useToast = ({ status, title = "", message = "", active, hasClose = true }) => {

  /** @type {React.ComponentType<{ children?: React.ReactNode }>} */
  const Portal = usePortal(toastHost);

  useEffect(() => () => toggleTopLayer(false), [toggleTopLayer]);

  const fullMessage = `${title ? `${title} - ` : ""}${message}`;

  return (
    <CSSTransition
      in={active}
      timeout={325}
      classNames="toast" // transition state classes will be applied to child (toast-enter-*)
      unmountOnExit
      onEnter={() => toggleTopLayer(true)}
      onExited={() => toggleTopLayer(false)}
    >
      <Portal>
        <Alert
          className={`toast toast-${status}`}
          rounded
          variant={status}
          message={fullMessage}
          hasClose={hasClose}
        />
      </Portal>
    </CSSTransition>
  );
};

export default useToast;
